// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9175) return "static/chunks/9175-b7a0c9dabd1df0f4.js";
	if (chunkId === 3850) return "static/chunks/3850-69678ef8a2030b20.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4348":"03af8267c32c7598","5150":"551edce5425c8c40"}[chunkId] + ".js";
};